/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.30.0
 */

import styled from 'styled-components';

import { colors } from '@theme/index';

export const ExternalLinkStyled = styled.a`
    color: ${colors.linkDefaultColor};

    &:hover {
        text-decoration: underline;
    }
`;
